import type { ReactNode } from 'react';

export const symbol_mail_shield: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M756-43.5q-5-.5-10-2.5-29-11-52-29.5T654-118q-20-29-31-63t-11-71v-79q0-8 4.5-15.5T629-358l110-56q13-6 27-6t27 6l110 56q8 4 12.5 11.5T920-331v79q0 37-11 71t-31 63q-17 24-40 42.5T786-46q-5 2-10 2.5t-10 .5q-5 0-10-.5Zm10-56.5q44-21 69-62t25-90v-61l-94-47v260ZM480-527l340-213H140l340 213ZM140-694v21-7 460-267 20-213 6-42.5.5-24 24q0-8 0 0v22ZM80-220v-520q0-23 18-41.5t42-18.5h680q23 0 41.5 18.5T880-740v255q0 17-14 25.5t-29 .5q-8-4-12.5-11.5T820-486v-194L496-473q-8 5-16 5t-16-5L140-680v460h384q13 0 21.5 8.5T554-190q0 13-8.5 21.5T524-160H143q-26 0-44.5-18.5T80-220Z"
		/>
	</svg>
);
